import React from 'react'
import { CheckoutElementsProvider } from '@stripe/react-stripe-js/checkout'
import stripePromise from './stripeClient'

// Supplied rather than collected: GCG is US-only, and country is the one billing address field Stripe
// will not let you unset — a form that suppresses it submits an empty value and Stripe rejects the
// update. So it is given up front instead of asked for.
const DEFAULT_BILLING_ADDRESS = { address: { country: 'US' } }

const CheckoutSessionElements = ({ clientSecret, appearance, children }) => {
    // Passes children through untouched when there is no session. That is not an edge case: coming back
    // from a redirect there is nothing left to pay for, only an order to finish, and the page still has
    // to render. Nothing below here may call useCheckout() unconditionally for the same reason.
    if (!clientSecret) {
        return children
    }

    // Keyed on the secret: a provider cannot be re-pointed at a different session, so without the
    // remount it would keep talking to a superseded one.
    return (
        <CheckoutElementsProvider
            key={clientSecret}
            stripe={stripePromise}
            options={{
                clientSecret,
                defaultValues: { billingAddress: DEFAULT_BILLING_ADDRESS },
                // 'never': the payment fields hold their own skeleton until the element reports
                // ready — Stripe's loader would be a second one appearing partway through the wait.
                elementsOptions: { appearance, loader: 'never' },
            }}
        >
            {children}
        </CheckoutElementsProvider>
    )
}

export default CheckoutSessionElements
